(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ops-style-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ops-style-description')) {
    customElements.define('ops-style-description', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        document.addEventListener('variant:update', event => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const html = event.detail?.data?.html;
          if (!html?.querySelectorAll) return;
          const source = Array.from(html.querySelectorAll('ops-style-description')).find(element => element.dataset.blockId === this.dataset.blockId && element.dataset.productId === this.dataset.productId);
          const content = source?.querySelector('[data-style-content]');
          if (content) this.querySelector('[data-style-content]').innerHTML = content.innerHTML;
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
